// ─────────────────────────────────────────────────────────────
// RAMAANI ELECTRICALS — single source of truth for business info.
// Store & product photos are still placeholders until provided.
// ─────────────────────────────────────────────────────────────

export const SITE = {
  name: "Ramaani Electricals",
  mark: "RAMAANI",
  sub: "Electricals · Vijayawada",
  tagline:
    "Vijayawada's one stop shop for wires, switchgear, lighting, fans and everything electrical — since 1997.",
  since: "1997",
  address: "Rajgruhi, Ground Floor, Sheshaiah Street, One Town, Vijayawada",
  phone: "+91 93987 15350",
  phoneHref: "tel:+919398715350",
  hours: "Mon – Sat · 10:00 AM – 9:00 PM",
  hoursSunday: "Sunday · 10:00 AM – 1:00 PM",
  mapEmbed:
    "https://maps.google.com/maps?q=Ramaani+Electricals+Sheshaiah+Street+Vijayawada&output=embed",
  mapsLink:
    "https://www.google.com/maps/dir/?api=1&destination=Ramaani+Electricals+Sheshaiah+Street+Vijayawada",
  googleUrl:
    "https://www.google.com/maps/search/Ramaani+Electricals+Sheshaiah+Street+Vijayawada",
  reviewUrl: "https://g.page/r/CZ2wj4jRUsDAEAE/review",
  instagram: "https://instagram.com/ramaani.electricals",
  instagramHandle: "@ramaani.electricals",
};

export const WHATSAPP = {
  number: "919398715350",
  display: "+91 93987 15350",
  presets: [
    "Hi Ramaani Electricals, I'd like to visit the experience centre — what are your timings today?",
    "Hi, I'm an electrician/contractor — can I get a demo of your range at the experience centre?",
    "Hi, do you have this in stock? I'd like to come see it in person.",
  ],
};

export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP.number}?text=${encodeURIComponent(msg)}`;

export const getOpenStatus = () => {
  const now = new Date();
  const isSunday = now.getDay() === 0;
  const mins = now.getHours() * 60 + now.getMinutes();
  const open = 10 * 60;
  const close = isSunday ? 13 * 60 : 21 * 60;
  if (mins >= open && mins < close) {
    return { open: true, label: `Open now · until ${isSunday ? "1:00 PM" : "9:00 PM"}` };
  }
  return { open: false, label: "Closed · opens 10:00 AM" };
};

export const REVIEWS = [
  {
    name: "Gopinaidu Manchikanti",
    text: "Excellent service and genuine products. The staff are very friendly, knowledgeable, and helped me choose the right items. Prices are reasonable, and the quality is excellent. I highly recommend this shop for all electrical and electronic needs. Will definitely visit again!",
  },
  {
    name: "Naren Babu Guduru",
    text: "First and foremost hospitality is great. Detailed explanation of products and prices. Best price in the market. Overall good experience.",
  },
  {
    name: "Besu Rabari",
    text: "Amazing variety at affordable prices, all brands at one place.",
  },
  {
    name: "Mani Nandipati",
    text: "Best rates and best quality products, super items and display.",
  },
  {
    name: "Manchikanti Gopichandu",
    text: "Good service and good prices.",
  },
];

export const BRANDS = [
  { name: "Legrand", logo: process.env.PUBLIC_URL + "/brands/legrand.png" },
  { name: "Finolex", logo: process.env.PUBLIC_URL + "/brands/finolex.png" },
  { name: "Polycab", logo: process.env.PUBLIC_URL + "/brands/polycab.png" },
  { name: "Elmeck", logo: process.env.PUBLIC_URL + "/brands/elmeck.png" },
  { name: "X-Press", logo: process.env.PUBLIC_URL + "/brands/xpress.png" },
  { name: "Crompton", logo: process.env.PUBLIC_URL + "/brands/crompton.png" },
  { name: "Atomberg", logo: process.env.PUBLIC_URL + "/brands/atomberg.png" },
  { name: "RR Kabel", logo: process.env.PUBLIC_URL + "/brands/rr-kabel.png" },
  { name: "Havells", logo: process.env.PUBLIC_URL + "/brands/havells.png" },
  { name: "Sturlite", logo: process.env.PUBLIC_URL + "/brands/sturlite.png" },
];

export const CATALOGUE = [
  {
    id: "wires-cables",
    name: "Wires & Cables",
    blurb: "House wiring to HT power cables, plus solar, EV and specialty cable.",
    groups: [
      { label: "House Wiring", items: ["FR Wires", "FRLS Wires", "Flexible Wires — 45/90m", "Flexible Wires — Project 180/300m"] },
      { label: "Power Cables", items: ["Armoured Cables", "Unarmoured Cables", "XLPE Cables", "LT Cables", "HT Cables"] },
      { label: "Communication Cables", items: ["LAN Cable (Cat6)", "Telephone Cable", "CCTV Cable", "Coaxial Cable", "Speaker Cable"] },
      { label: "Solar & EV", items: ["DC Solar Cable", "AC Solar Cable", "EV Charging Cable"] },
      { label: "Specialty", items: ["Submersible Cable", "Flat Cable"] },
    ],
  },
  {
    id: "switches-modular",
    name: "Switches & Modular Accessories",
    blurb: "Modular ranges from every major brand, with plates and accessories to match.",
    groups: [
      { label: "Range", items: ["Modular Switches", "Modular Plates & Accessories"] },
    ],
  },
  {
    id: "switchgear-protection",
    name: "Switchgear & Protection",
    blurb: "MCBs to MCCBs, distribution boards and enclosures for every load.",
    groups: [
      { label: "Switchgear", items: ["MCBs", "RCCB / RCD", "RCBO", "Isolators", "MCCB", "ELCB", "Changeover Switch", "ACCL"] },
      { label: "Distribution Boards", items: ["SPN DB", "TPN DB", "Metal Enclosures", "Double Door DB", "Waterproof Enclosures"] },
    ],
  },
  {
    id: "lighting",
    name: "Lighting",
    blurb: "Indoor, outdoor and industrial lighting — from COBs to high bays.",
    groups: [
      { label: "Indoor", items: ["Ceiling Lights", "Downlights", "COB Lights", "Decorative Lights", "Profile Lighting", "Strip Lighting", "Spot Lights", "Magnetic Track Lighting", "Batten Lights"] },
      { label: "Outdoor", items: ["Flood Lights", "Street Lights", "Garden Lights", "Spike Lights", "Bollard Lights", "Gate Pillar Lights", "Wall Washer Lights", "Landscape Lights"] },
      { label: "Industrial", items: ["High Bay Lights", "Low Bay Lights"] },
    ],
  },
  {
    id: "fans",
    name: "Fans & Ventilation",
    blurb: "Ceiling, smart, exhaust and industrial fans for every room and site.",
    groups: [
      { label: "Range", items: ["Ceiling Fans", "Smart Fans", "Wall Fans", "Exhaust Fans", "Pedestal Fans", "Table Fans", "Industrial Fans"] },
    ],
  },
  {
    id: "home-appliances",
    name: "Home Appliances",
    blurb: "Geysers, purifiers, chimneys and everyday appliances on the shelf.",
    groups: [
      { label: "Range", items: ["Water Heater (Geyser)", "Room Heater", "Water Purifier", "Chimneys", "Air Purifier", "Iron", "Exhaust Fan"] },
    ],
  },
  {
    id: "conduit-enclosures",
    name: "PVC Conduit & Enclosures",
    blurb: "Conduits, fittings, metal boxes and IP-rated industrial enclosures.",
    groups: [
      { label: "Conduits & Fittings", items: ["Bends", "Couplers", "Junction Boxes", "Inspection Boxes", "Pipes"] },
      { label: "Metal & Electrical Boxes", items: ["Metal Boxes", "Junction Boxes", "Weatherproof Boxes", "Waterproof Enclosures"] },
      { label: "Industrial Enclosures", items: ["PVC Enclosures", "Metal Enclosures", "Junction Boxes", "IP65 Enclosures", "IP67 Enclosures"] },
    ],
  },
  {
    id: "earthing-lightning",
    name: "Earthing & Lightning Protection",
    blurb: "Chemical, copper and GI earthing with every accessory to finish the job.",
    groups: [
      { label: "Earthing", items: ["Chemical Earthing", "Copper Earthing", "GI Earthing", "Earthing Electrodes"] },
      { label: "Accessories", items: ["Earth Pit Covers", "Earth Enhancement Compound", "Earthing Strip", "Earthing Wire", "Clamps", "Lightning Arresters"] },
    ],
  },
  {
    id: "cable-management",
    name: "Cable Management",
    blurb: "Trunking, trays, raceways and ducts for clean, serviceable runs.",
    groups: [
      { label: "Range", items: ["PVC Trunking", "GI Cable Tray", "Perforated Tray", "Ladder Tray", "Raceway", "Cable Duct"] },
    ],
  },
  {
    id: "accessories",
    name: "Tools & Accessories",
    blurb: "Connection and installation hardware — the small things that hold up a project.",
    groups: [
      { label: "Connection Accessories", items: ["Cable Tie", "Cable Gland", "Ferrules", "Copper & Aluminium Lugs", "Connector Strip"] },
      { label: "Hardware & Installation", items: ["Screws", "Wall Plugs", "Anchor Fasteners", "GI & PVC Clamps"] },
    ],
  },
];

export const itemCount = (c) => c.groups.reduce((n, g) => n + g.items.length, 0);

export const TIMELINE = [
  {
    year: "1997",
    title: "The First Counter",
    desc: "Ramaani Electricals opens on Sheshaiah Street, One Town — a single counter, a small godown, and a promise of genuine stock at honest prices.",
  },
  {
    year: "2006",
    title: "The One Stop Shop",
    desc: "From wires to switchgear to lighting, the shelves grow until a contractor can source an entire project in a single visit.",
  },
  {
    year: "2016",
    title: "Lighting & Appliances Floor",
    desc: "A full lighting display and home-appliances section joins the trade counter — from COBs and profile lighting to geysers and chimneys.",
  },
  {
    year: "2026",
    title: "Solar, EV & Smart",
    desc: "Solar cable, EV charging and smart fans arrive on the shelves — the newest technology, backed by the same Sheshaiah Street handshake.",
  },
];

export const DELIVERY_CITIES = [
  "Vijayawada",
  "Guntur",
  "Visakhapatnam",
  "Tirupati",
  "Nellore",
  "Kakinada",
  "Rajahmundry",
  "Eluru",
  "Ongole",
  "Tenali",
  "Mangalagiri",
  "Amaravati",
];

export const PILLARS = [
  {
    num: "01",
    title: "Genuine, Authorised Stock",
    desc: "Every box is factory-sealed and BIS-certified, sourced directly as an authorised dealer. No seconds, no grey market — ever.",
  },
  {
    num: "02",
    title: "Trade & Contractor Pricing",
    desc: "Electricians, contractors and builders get honest trade rates at the counter — and consistent pricing on every repeat order.",
  },
  {
    num: "03",
    title: "Everything Under One Roof",
    desc: "Wires to switchgear to lighting to fans — ten full categories in one shop, so your project never waits on a missing part.",
  },
  {
    num: "04",
    title: "Trusted Since 1997",
    desc: "Nearly three decades on the same street, serving the same families, firms and sites. Our word is our warranty.",
  },
  {
    num: "05",
    title: "Same-Day Availability",
    desc: "Deep stock across fast-moving lines means you walk out with what you came for — or we source it for you, fast.",
  },
];

// PLACEHOLDER photos — to be replaced with real store photos.
export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1663811397219-c572550dffc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsaXZpbmclMjByb29tJTIwaG9tZSUyMGNpbmVtYXxlbnwwfHx8fDE3ODY1NTUxODd8MA&ixlib=rb-4.1.0&q=85",
  showroom: "https://images.unsplash.com/photo-1538431347070-1068ff5e62e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvciUyMGFyY2hpdGVjdHVyZSUyMHN0b3JlfGVufDB8fHx8MTc4NjU1NTE4N3ww&ixlib=rb-4.1.0&q=85",
  facade: "https://images.unsplash.com/photo-1606132653399-36248f2e2a99?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBpbnRlcmlvciUyMGFyY2hpdGVjdHVyZSUyMHN0b3JlfGVufDB8fHx8MTc4NjU1NTE4N3ww&ixlib=rb-4.1.0&q=85",
  acoustic: "https://images.unsplash.com/photo-1667746213225-431db3ed8d13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHxfHxsdXh1cnklMjBpbnRlcmlvciUyMGFyY2hpdGVjdHVyZSUyMHN0b3JlfGVufDB8fHx8MTc4NjU1NTE4N3ww&ixlib=rb-4.1.0&q=85",
  smartLiving: "https://images.unsplash.com/photo-1724582586508-8f06117dc979?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tJTIwaG9tZSUyMGNpbmVtYXxlbnwwfHx8fDE3ODY1NTUxODd8MA&ixlib=rb-4.1.0&q=85",
  speaker: "https://images.unsplash.com/photo-1621266034770-74d35534f9ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBraXRjaGVuJTIwYXBwbGlhbmNlJTIwc3BlYWtlcnxlbnwwfHx8fDE3ODY1NTUxOTB8MA&ixlib=rb-4.1.0&q=85",
  kitchen: "https://images.unsplash.com/photo-1639405069836-f82aa6dcb900?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjBraXRjaGVuJTIwYXBwbGlhbmNlJTIwc3BlYWtlcnxlbnwwfHx8fDE3ODY1NTUxOTB8MA&ixlib=rb-4.1.0&q=85",
  vip: "https://images.unsplash.com/photo-1724582586495-d050726cf354?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHxfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tJTIwaG9tZSUyMGNpbmVtYXxlbnwwfHx8fDE3ODY1NTUxODd8MA&ixlib=rb-4.1.0&q=85",
};

// Real store photos (user-provided). Titles = file names. First 4 are the
// pinned order shown before "View Full Gallery"; the rest appear on expand.
export const GALLERY = [
  { src: process.env.PUBLIC_URL + "/gallery/the-counter.jpeg", title: "The counter" },
  { src: process.env.PUBLIC_URL + "/gallery/display.jpeg", title: "Display" },
  { src: process.env.PUBLIC_URL + "/gallery/lighting.jpeg", title: "Lighting" },
  { src: process.env.PUBLIC_URL + "/gallery/facade.jpeg", title: "Facade" },
  { src: process.env.PUBLIC_URL + "/gallery/the-shelves.jpeg", title: "The shelves" },
  { src: process.env.PUBLIC_URL + "/gallery/outdoor-seating.jpeg", title: "Outdoor seating" },
  { src: process.env.PUBLIC_URL + "/gallery/the-main-aisle.jpeg", title: "The main aisle" },
];
